// extracted by mini-css-extract-plugin
module.exports = {"contii":"style_contii__3ca0g","bgg":"style_bgg__6bw9c","wrapp":"style_wrapp__10OJG","title":"style_title__dQBq2","myp":"style_myp__3RGyc","container":"style_container__ttJo8"};